/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const SubtitleStylesIcon = ({ width = 16, height = 12, color = '#F7F9FA', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 12' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.799988 0.792882C0.799988 0.575913 0.979074 0.400024 1.19999 0.400024H9.19999C9.4209 0.400024 9.59999 0.575913 9.59999 0.792882C9.59999 1.00985 9.4209 1.18574 9.19999 1.18574H5.59999V11.0072C5.59999 11.2241 5.4209 11.4 5.19999 11.4C4.97907 11.4 4.79999 11.2241 4.79999 11.0072L4.79999 1.18574H1.19999C0.979074 1.18574 0.799988 1.00985 0.799988 0.792882ZM9.59999 4.72145C9.59999 4.50448 9.77907 4.3286 9.99999 4.3286H14.8C15.0209 4.3286 15.2 4.50448 15.2 4.72145C15.2 4.93842 15.0209 5.11431 14.8 5.11431H12.8V11.0072C12.8 11.2241 12.6209 11.4 12.4 11.4C12.1791 11.4 12 11.2241 12 11.0072V5.11431H9.99999C9.77907 5.11431 9.59999 4.93842 9.59999 4.72145Z'
    />
  </svg>
);

export default SubtitleStylesIcon;
